import { createBrowserRouter, isRouteErrorResponse, useRouteError } from 'react-router';
import { Layout } from './components/Layout';
import { PortfolioPage } from './pages/PortfolioPage';
import { ContactPage } from './pages/ContactPage';
import { loadSnapshot } from './lib/snapshot';

export const router = createBrowserRouter([
  {
    id: 'root',
    loader: loadSnapshot,
    // The published snapshot is loaded once per visit; navigation never needs to refetch it.
    shouldRevalidate: () => false,
    element: <Layout />,
    HydrateFallback: () => null,
    errorElement: <RootError />,
    children: [
      { index: true, element: <PortfolioPage /> },
      { path: 'contact', element: <ContactPage /> },
    ],
  },
  {
    // Code-split so public visitors never download the admin bundle.
    path: 'admin/*',
    HydrateFallback: () => null,
    lazy: async () => ({ Component: (await import('./admin/AdminApp')).AdminApp }),
  },
]);

function RootError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeContent: 'center',
        textAlign: 'center',
        padding: 24,
      }}
    >
      <p className="label">{notFound ? 'Not found' : 'Something went wrong'}</p>
      <p>
        <a href="/">Return to the portfolio</a>
      </p>
    </main>
  );
}
